import axios from "api/index";

export const logUserActivity = async (empId, path , pageName) => {
  try {
    const payload = {
     UserId: empId,
      PageRoute: path,
      ActionType: "Visit",
      pageName,
      timestamp: new Date().toISOString(),
    };
    console.log("payoad" , payload)    
   const response=  await axios.post("/UserActivity/PortalLogActivity", payload);
   console.log(response);
    // you can add console.log("Activity logged", payload) for debug
  } catch (error) {
    console.error("❌ Failed to log activity:", error);
  }
};
